/**
 * 主应用组件
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './components/MainLayout';
import Login from './pages/Login';
import TestLogin from './pages/TestLogin';
import TemplateList from './pages/TemplateList';
import TemplateForm from './pages/TemplateForm';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import UserDetail from './pages/UserDetail';
import PromptFilter from './pages/PromptFilter';
import PurchaseList from './pages/PurchaseList';
import FeedbackList from './pages/FeedbackList';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

const AttributionDashboard = React.lazy(
  () => import('./pages/AttributionDashboard')
);
const VidBomGrowthDashboard = React.lazy(
  () => import('./pages/VidBomGrowthDashboard')
);

// 配置 dayjs 中文
dayjs.locale('zh-cn');

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* 登录页 */}
            <Route path="/login" element={<Login />} />
            <Route path="/test-login" element={<TestLogin />} />

            {/* 主应用 - 需要认证 */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              {/* 默认重定向到数据统计 */}
              <Route index element={<Navigate to="/dashboard" replace />} />
              
              {/* 数据统计 */}
              <Route path="dashboard" element={<Dashboard />} />
              
              {/* 用户管理 */}
              <Route path="users" element={<UserList />} />
              <Route path="users/:device_id" element={<UserDetail />} />
              
              {/* 充值记录 */}
              <Route path="purchases" element={<PurchaseList />} />

              {/* 增长分析 */}
              <Route
                path="attribution"
                element={
                  <React.Suspense
                    fallback={
                      <div style={{ padding: 80, textAlign: 'center' }}>
                        <Spin size="large" />
                      </div>
                    }
                  >
                    <AttributionDashboard />
                  </React.Suspense>
                }
              />

              <Route
                path="attribution/vidbom"
                element={
                  <React.Suspense
                    fallback={
                      <div style={{ padding: 80, textAlign: 'center' }}>
                        <Spin size="large" />
                      </div>
                    }
                  >
                    <VidBomGrowthDashboard />
                  </React.Suspense>
                }
              />
              
              {/* Prompt 过滤 */}
              <Route path="filters" element={<PromptFilter />} />
              
              {/* 客诉反馈 */}
              <Route path="feedback" element={<FeedbackList />} />
              
              {/* 模板管理 */}
              <Route path="templates" element={<TemplateList />} />
              <Route path="templates/create" element={<TemplateForm />} />
              <Route path="templates/edit/:id" element={<TemplateForm />} />
              
              {/* 个人信息（占位） */}
              <Route
                path="profile"
                element={
                  <div style={{ textAlign: 'center', padding: 50 }}>
                    <h2>个人信息</h2>
                    <p>功能开发中...</p>
                  </div>
                }
              />
            </Route>

            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
